export default {
    url: '/edit/:id',
    template: '<manage-permissions-companies-edit company="vm.company" countries="vm.countries"/>',
    resolve: {
        company (CompanyResource, $stateParams) {
            return CompanyResource.get({ id: $stateParams.id, expand: 'languages' }).$promise;
        },
        countries (CountryResource) {
            return CountryResource.query().$promise;
        }
    },
    controller (company, countries) {
        this.company = company;
        this.countries = countries;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/companies/edit/index.js